import ServiceExec from '@/common/utils/ServiceExec';
import { common } from '@/common/service/ApiList';
const actions = {
  async initialize({ state, commit }) {
    const response = await ServiceExec.get(common.enumModel);
    const { data } = response;
    commit('setConstants', data);
  }
};
export default actions;
